"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../shared/types");
const newTracedFetch_1 = __importDefault(require("../../shared/helpers/newTracedFetch"));
const toConsoleFunction_1 = __importDefault(require("../../shared/helpers/toConsoleFunction"));
const edge_1 = require("../edge");
const getLocalLogArguments_1 = __importDefault(require("../getLocalLogArguments"));
const shared_1 = require("../../shared");
class HypertuneEdgeInitDataProvider {
    // eslint-disable-next-line max-params
    constructor({ baseUrl, token, branchName = null, localLogger = defaultLocalLogger, timeoutMs = 10000, }) {
        if (branchName !== null && branchName !== shared_1.defaultBranchName) {
            localLogger(types_1.LogLevel.Warn, `using non default branch name: "${branchName}"`, {});
        }
        this.baseUrl = baseUrl;
        this.token = token;
        this.branchName = branchName;
        this.tracedFetch = (0, newTracedFetch_1.default)({
            timeoutMs,
            localLogger,
        });
    }
    // eslint-disable-next-line class-methods-use-this
    getName() {
        return "Hypertune Edge";
    }
    getInitData({ traceId, initQuery, variableValues, }) {
        return (0, edge_1.initRequest)({
            traceId,
            query: initQuery,
            variables: variableValues,
            token: this.token,
            branchName: this.branchName,
            edgeBaseUrl: this.baseUrl,
            tracedFetch: this.tracedFetch,
        });
    }
    getInitDataHash({ traceId, initQuery, variableValues, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { hash } = yield (0, edge_1.hashRequest)({
                traceId,
                query: initQuery,
                variables: variableValues,
                token: this.token,
                branchName: this.branchName,
                edgeBaseUrl: this.baseUrl,
                tracedFetch: this.tracedFetch,
            });
            return hash;
        });
    }
}
exports.default = HypertuneEdgeInitDataProvider;
function defaultLocalLogger(level, message, metadata) {
    if (level === types_1.LogLevel.Debug) {
        return;
    }
    (0, toConsoleFunction_1.default)(level)(...(0, getLocalLogArguments_1.default)(message, metadata));
}
//# sourceMappingURL=HypertuneEdgeInitDataProvider.js.map